// Module
var code = " <div class=\"privacyDiv\"> <div class=\"privacyTitle\"> <span ng-bind=\"model.privacyPolicyUpdate\"></span> </div> <div class=\"privacycontent\"> <span ng-bind=\"model.privacyTipPre\"></span> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{{model.privacyAgreement}}\" ng-bind=\"model.secretprotect\"></a> <span ng-bind=\"model.privacyTipSuf\"></span> </div> <div id=\"btnDiv\"> <button id=\"submitBtn\" class=\"okButton\" ng-click=\"onSubmitClick()\" ng-disabled=\"model.disable\" ng-bind=\"model.btnTxtOK\"></button> <button id=\"cancelBtn\" class=\"cancelButton\" style=\"margin-left:10px\" ng-click=\"onCancelClick()\" ng-bind=\"model.btnTxtCancel\"></button> </div> </div> <div id=\"popupMsg\"></div> ";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/privacyUpdate/views/content.html
// module id = 249
// module chunks = 0